import React from 'react'

/**
 * State the shell publishes to everything it renders — label, control,
 * launcher, read-only body. This is the ONLY source of truth for a
 * field's error state: `hasError` here has already been through
 * `filterUiErrors` and the section's submit-time required-error gate,
 * so a field that re-derives `!isEmpty(props.errors)` locally will
 * disagree with the error message the shell renders.
 */
export interface IFieldShellContext {
  isDisabled: boolean
  /** Effective read-only — plain `isReadOnly` OR prefilled-display mode. */
  isReadOnly: boolean
  hasError: boolean
  errorText?: string
  prefilledCancelNode?: React.ReactNode
  // Inline help text forwarded into horizontal layout footer slots (web only).
  footerContent?: React.ReactNode
}

const defaultContext: IFieldShellContext = {
  isDisabled: false,
  isReadOnly: false,
  hasError: false,
}

export const FieldShellContext = React.createContext<IFieldShellContext>(defaultContext)

export const useFieldShellContext = (): IFieldShellContext => React.useContext(FieldShellContext)
